import React, { useContext, useEffect, useState } from 'react';
import {
  BrowserRouter as Router,
  Routes,
  Route,
  useLocation,
  Navigate
} from 'react-router-dom';

import { trackPage } from './analytics.js'; // sau ./analytics dacă redenumești

import { Header } from './header/Header';
import { Home } from './content/Home';
import { About } from './footer/About';
import CursuriPresentation from './footer/CursuriPresentation';
import JocuriPresentation from './footer/JocuriPresentation';

import { Registrer } from './content/Registrer';
import { Login } from './content/Login';
import { AuthProvider } from './AuthContext';
import { DarkModeProvider, useDarkMode } from './DarkModeContext';
import LoadingOverlay from './content/LoadingOverlay';
import Maintenance from './Maintenance';
import './styles/darkmode.css';
import FooterBlog from './content/blog/FooterBlog';
import VerifyCertificate from './diploma/VerifyCertificate.jsx';
import OnboardingIntro from './quizstart/OnboardingIntro.jsx';

import ContaPrimara from './content/cursuri/contaprimara/ContaPrimara.jsx';
import ContaPrimaraCourse from './content/cursuri/contaprimara/ContaPrimaraCourse.jsx';
import ContaPrimaraSyllabus from './content/cursuri/contaprimara/ContaPrimaraSyllabus.jsx';



import MenuFooter from './footer/MenuFooter';




import EmailConnect from './content/EmailConnect';
import ForgotPassword from './content/ForgotPassword';
import ResetPassword from './content/ResetPassword';

import RedirectAfterLogin from './RedirectAfterLogin';

import ConfirmationPage from './content/ConfirmationPage';
// ...existing code...

import FinancialCourse from './content/cursuri/contafinanciara/FinancialCourse';



















import { Footer } from './footer/Footer';
import './App.css';
import { LessonsContainer } from './content/lessons/LessonsContainer';




import Finaloffer from './header/offer/Finaloffer';

import Paymentpage from './header/offer/Paymentpage';

import Facturare from './header/offer/Facturare';
import ResetareProgres from './content/ResetareProgres';
import LessonsLayout from './content/LessonsLayout';

import PlanLunar from './header/offer/PlanLunar';
import PlanAnual from './header/offer/PlanAnual';
import PlanGratuit from './header/offer/PlanGratuit';



import BazeleConta from './content/coursesandgamespage/BazeleConta';
import ContaFinanciara from './content/coursesandgamespage/ContaFinanciara';


import FunctionalPageLogin from './content/functionalpagelogin/FunctionalPageLogin.jsx';

import PracticeApp from './content/cursuri/contafinanciaraaplicata/practiceApp.jsx';


import Blog from './content/blog/Blog.jsx';
import CheckCertification from './content/functionalpagelogin/InsideFooter/CheckCertification';
import CertificateInfo from './content/functionalpagelogin/InsideFooter/CertificateInfo';


import QuizStart from './quizstart/QuizStart';
import ScrollToTop from './ScrollToTop';
import Chaptercontainer from './content/cursuri/Chaptercontainer';

import Setari from './users/Setari';
import PlanulTau from './users/PlanulTau';
import Settings from './settings/Settings';
import Ajutor from './users/Ajutor';
//import ProtectedRoute from './ProtectedRoute';
import DiplomaPage from './diploma/DiplomaPage';
import Diplome from './users/Diplome';
import CoursesProgressPage from './users/CoursesProgressPage';
import Medals from './users/Medals';

import FAQ from './footer/FAQ';
import Termeni from './footer/Termeni';

import Cariere from './footer/Cariere';
import { Feedback } from './footer/Feedback';




import Politica from './footer/Politica';
import Politicacookies from './footer/Politicacookies';
import GDPR from './footer/GDPR';
import ANPC from './footer/ANPC';
//import { publicRoutes } from './content/publicRoutes';

import CookieConsent from './CookieConsent'; 
import { redirectToLogin } from './utils/authRedirect';
import Cookies from 'js-cookie';

const AdminDashboard = React.lazy(() => import('./admin/AdminDashboard'));






// Adaugă URL-ul API-ului folosind variabila de mediu
const apiUrl = process.env.REACT_APP_API_URL;
const protectedRoutes = new Set([
  '/admin',
  '/functionalpagelogin',
  '/chaptercontainer',
  '/chaptercontainercf',
  '/showlessons',
  '/showlessonscf',
  '/setari',
  '/settings',
 '/check-certification',
 '/certification',
  '/diploma',
  '/diplome',
  '/courses-progress',
  '/medals',
  '/userpage'
]);

const isProtectedRoute = (pathname) => protectedRoutes.has(pathname.toLowerCase());


function AppContent() {
  const location = useLocation();
  const [loading, setLoading] = useState(false);
  const { user, loading: authLoading } = require('./AuthContext').useAuth();





useEffect(() => {
  trackPage(location.pathname + location.search);
}, [location]);

  useEffect(() => {
    if (!authLoading && !user && isProtectedRoute(location.pathname)) {
      redirectToLogin();
    }
  }, [authLoading, location.pathname, user]);



     // pornește overlay la fiecare schimbare de rută
  useEffect(() => {
    setLoading(true);
    const t = setTimeout(() => setLoading(false), 100); // 0.6s pauză
    return () => clearTimeout(t);
  }, [location.pathname]);

  const lessonIsActive = location.pathname === '/chaptercontainer';
  const lessonCfIsActive = location.pathname === '/chaptercontainercf';
  const showLessonIsActive = location.pathname === '/showlessons';
  const showLessonCfIsActive = location.pathname === '/showlessonscf';

 const path = location.pathname.toLowerCase();

const showMenuFooter = (
  path === '/about' ||
  path === '/cariere' ||
  path === '/feedback' ||
  path === '/cursuri-prezentare' ||
  path === '/jocuri-prezentare' ||
  path === '/faq' ||
  path === '/termeni' ||
  path === '/politica' ||
  path === '/politicacookies' ||
  path === '/gdpr' ||
  path === '/anpc' ||
  path === '/ajutor'
);






const BlogIsActive = location.pathname.startsWith('/blog');
  
  const FinalofferActive = location.pathname === '/finaloffer';
  const PaymentpageActive = location.pathname === '/paymentpage';
  const ContaPrimaraIsActive = location.pathname === '/contabilitate-primara/lesson';

  const functionalpageloginActive = location.pathname === '/functionalpagelogin';
  const onboardingIntroActive = location.pathname === '/onboarding-intro';
 

 const CheckCertificationIsActive = location.pathname === '/check-certification';
  const FacturareActive = location.pathname === '/facturare';
  const redirectingActive = location.pathname === '/redirecting'; // 👈 ADĂUGAT
  const mentenanceActive = location.pathname === '/mentenance';


  
  const DiplomaIsActive = location.pathname === '/diploma';
  const DiplomeIsActive = location.pathname === '/diplome';
  const CoursesProgressActive = location.pathname === '/courses-progress';
  const SetariIsActive = location.pathname === '/setari';










  const hideHeader = (
    lessonIsActive ||
    lessonCfIsActive ||
    onboardingIntroActive ||
    functionalpageloginActive ||
    BlogIsActive ||
    CheckCertificationIsActive ||
    FinalofferActive ||
    PaymentpageActive ||
    FacturareActive ||
    showLessonIsActive ||
    showLessonCfIsActive ||
    SetariIsActive ||
    mentenanceActive ||
    DiplomaIsActive ||
    DiplomeIsActive ||
    CoursesProgressActive ||
    redirectingActive ||
    ContaPrimaraIsActive ||

    location.pathname === '/quiz-start' // ascunde header pe pagina quiz
  );

  const hideFooter = (
    location.pathname === '/quiz-start' ||
    lessonIsActive ||
    lessonCfIsActive ||
    showLessonIsActive ||
    showLessonCfIsActive ||  
 onboardingIntroActive ||
    functionalpageloginActive ||

    ContaPrimaraIsActive ||
    mentenanceActive ||
    location.pathname === '/setari' ||
    DiplomaIsActive ||
    FinalofferActive ||
    PaymentpageActive ||
    FacturareActive ||
    redirectingActive // 👈 ADĂUGAT
  );

  if (!authLoading && !user && isProtectedRoute(location.pathname)) {
    return null;
  }

  // Redirecționează userul autentificat de pe /home sau / către /functionalpagelogin
  if (!authLoading && user && (location.pathname === '/home' || location.pathname === '/')) {
    return <Navigate to="/functionalpagelogin" replace />;
  }

  return (
    <>
      {loading && location.pathname !== '/redirecting' && <LoadingOverlay />}
      <CookieConsent />
  
      {!hideHeader && (showMenuFooter ? <MenuFooter /> : <Header />)}

      <div className="d-flex flex-column v-100">
        <Routes>
           <Route path="/functionalpagelogin" element={<FunctionalPageLogin />} />
            <Route path="/userpage" element={<Navigate to="/functionalpagelogin" replace />} />
         <Route
  path="/onboarding-intro"
  element={<OnboardingIntro />}
/>
<Route
  path="/contabilitate-primara/lesson"
  element={<ContaPrimara />}
/>
<Route
  path="/curs_conta-primara"
  element={<ContaPrimaraCourse />}
/>
          <Route path="/quiz-start" element={<QuizStart />} />
          <Route path="/" element={<Home />} />
          <Route path="home" element={<Navigate to="/" replace />} />
           <Route path="mentenance" element={<Maintenance />} />
          <Route path="/about" element={<About />} />
          <Route path="/cariere" element={<Cariere />} />
          <Route path="/feedback" element={<Feedback />} />
          <Route path="/cursuri-prezentare" element={<CursuriPresentation />} />
          <Route path="/jocuri-prezentare" element={<JocuriPresentation />} />
          <Route
  path="/verify/:certificateCode"
  element={<VerifyCertificate />}
/>


<Route path="/practiceapp" element={<PracticeApp />} />


          
          <Route path="/login" element={Cookies.get('cookieConsent') ? <Login /> : <Navigate to="/" replace />} />
          <Route path="/emailconnect" element={Cookies.get('cookieConsent') ? <EmailConnect /> : <Navigate to="/" replace />} />
          <Route path="/forgot-password" element={<ForgotPassword />} />
          <Route path="/reset-password" element={<ResetPassword />} />
          <Route path="/confirmationemail" element={<ConfirmationPage />} />
          <Route path="/registrer" element={Cookies.get('cookieConsent') ? <Registrer /> : <Navigate to="/" replace />} />
          <Route path="/lessonscontainer" element={<LessonsContainer />} />
          
          <Route path="/blog" element={<Blog />} />
          <Route path="/check-certification" element={<CheckCertification />} />
          <Route
  path="/certification"
  element={<CertificateInfo />}
/>
          <Route path="/chaptercontainer" element={<Chaptercontainer />} />
          <Route
  path="/showlessons-financial"
  element={<FinancialCourse />}
/>

<Route
  path="/contabilitate-primara/programa"
  element={<ContaPrimaraSyllabus />}
/>
        
          
          <Route path="/faq" element={<FAQ />} />
       
          <Route path="/termeni" element={<Termeni />} />
          <Route path="/politica" element={<Politica />} />
          <Route path="/politicacookies" element={<Politicacookies />} />
          <Route path="/gdpr" element={<GDPR />} />
          <Route path="/anpc" element={<ANPC />} />
       
        
         
          <Route path="/finaloffer" element={<Finaloffer />} />
        
         
          <Route path="/facturare" element={<Facturare />} />
          <Route path="/resetareprogres" element={<ResetareProgres />} />
          <Route path="/paymentpage" element={<Paymentpage />} />
          <Route path="/redirecting" element={<RedirectAfterLogin />} />
        
          
          <Route path="/bazeleconta" element={<BazeleConta />} />
          <Route path="/contafinanciara" element={<ContaFinanciara />} />
         
<Route
  path="/chapter-preview/:chapterId"
  element={<FunctionalPageLogin />}
/>
          <Route path="/setari" element={<Setari />} />
          <Route path="/settings" element={<Settings />} />
          <Route path="/admin" element={<React.Suspense fallback={null}><AdminDashboard /></React.Suspense>} />

          <Route path="/ajutor" element={<Ajutor />} />

        <Route element={<LessonsLayout />}>
          <Route path="/diploma" element={<DiplomaPage />} />
          <Route path="/diplome" element={<Diplome />} />
          <Route path="/courses-progress" element={<CoursesProgressPage />} />
          <Route path="/medals" element={<Medals />} />
        </Route>

          {/* Showlessons cu alt meniu */}
// ...existing code...

        <Route
  path="/showlessonscf"
  element={<FinancialCourse />}
/>
       
    



   


        </Routes>
      </div>

     {!hideFooter && (
  BlogIsActive
    ? <FooterBlog />
    : <Footer />
)}
    </>
  );
}



function App() {
  return (
    <AuthProvider>
      <DarkModeProvider>
        <Router>
          <ScrollToTop />
          <AppContent />
        </Router>
      </DarkModeProvider>
    </AuthProvider>
  );
}




// Componenta principală




export default App;
